import { Flex, Spinner, Text, VStack } from '@chakra-ui/react'
import React from 'react'
import { Navigate } from 'react-router-dom'
import { useLanguage } from '../hooks/utility/useLanguage'
import { useUser } from '../hooks/auth/useUser'

interface ReshapedAdminRouteProps {
  children: React.ReactElement
}

/**
 * Only reshaped admins (`User.is_reshaped_admin`) pass; everyone else is sent
 * home. Client superusers are deliberately not enough — feature flags change
 * what the whole deployment does.
 */
const ReshapedAdminRoute: React.FC<ReshapedAdminRouteProps> = ({ children }) => {
  const { data: user, isLoading } = useUser()
  const { t } = useLanguage()

  if (isLoading) {
    return (
      <Flex justify='center' align='center' height='100vh'>
        <VStack spacing={4}>
          <Spinner size='xl' color='primary' thickness='4px' />
          <Text color='gray.600'>{t('common.loading')}</Text>
        </VStack>
      </Flex>
    )
  }

  if (!user?.is_reshaped_admin) {
    return <Navigate to='/' replace />
  }

  return children
}

export default ReshapedAdminRoute
